import React from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import "react-loading-skeleton/dist/skeleton.css";
import {
  ResponsiveModal,
  useIsOverlayDrawer,
  modalTitleId,
} from "./ResponsiveModal";

// Re-exported so existing `import { useIsOverlayDrawer } from "./Overlay"` keeps working.
export { useIsOverlayDrawer };

const Puller = styled(Box)({
  width: 48,
  height: 4,
  backgroundColor: "#9897A9",
  borderRadius: 3,
  position: "absolute",
  top: 16,
  left: "calc(50% - 24px)",
});

// "Panel" modal: title left-aligned with the close icon on the same row,
// left-aligned scrollable content. For forms, lists and details.
export default function Overlay({
  open,
  handleClose,
  id,
  titleText,
  size = "lg",
  width = undefined,
  maxHeight = undefined,
  children,
  overflowHidden = false,
  titleAlignTop = false,
  titlePaddingBottom = undefined,
  contentSx = undefined,
}) {
  const dialogWidth =
    width ?? (size === "sm" ? 515 : size === "md" ? 900 : 1212);

  const drawerContent = (
    <>
      <Box sx={{ bgcolor: "#fff", position: "relative", pt: 2 }}>
        <Puller />
        {/* tickets.css gives .r_drawerTitle margin-top: 40px (shared with the
            legacy drawers); Overlay's drawer title sits 16px below the puller area. */}
        <div className="r_drawerTitle" style={{ marginTop: 16 }}>
          <div
            id={modalTitleId(id)}
            className="r_dialogTitleText"
            style={{ marginBottom: 0, fontSize: 16 }}
          >
            {titleText ?? ""}
          </div>
        </div>
      </Box>
      <Box sx={{ bgcolor: "#fff", px: 2, pb: 2, overflow: "auto" }}>
        {children}
      </Box>
    </>
  );

  const dialogContent = (
    <>
      <DialogTitle
        className="r_dialogTitle"
        sx={{
          padding: "24px !important",
          ...(titleAlignTop && { alignItems: "flex-start !important" }),
          ...(titlePaddingBottom != null && {
            paddingBottom: `${titlePaddingBottom}px !important`,
          }),
        }}
      >
        <div
          id={modalTitleId(id)}
          className="r_dialogTitleText"
          style={{ marginBottom: 0 }}
        >
          {titleText ?? ""}
        </div>
        <CloseIcon
          onClick={() => handleClose()}
          className="r_dialogTitleIcon"
          style={{ color: "#0D0C1C" }}
        />
      </DialogTitle>
      <DialogContent
        sx={[
          overflowHidden && { overflow: "hidden !important" },
          ...(Array.isArray(contentSx) ? contentSx : [contentSx]),
        ].filter(Boolean)}
      >
        {children}
      </DialogContent>
    </>
  );

  return (
    <>
      {/* Kept from the original Overlay: pages that mount an Overlay have
          always had MUI's CssBaseline applied, and some may rely on it. */}
      <CssBaseline />
      <ResponsiveModal
        open={open}
        onClose={handleClose}
        id={id}
        width={dialogWidth}
        radius={8}
        maxHeight={maxHeight}
        drawerContent={drawerContent}
        dialogContent={dialogContent}
      />
    </>
  );
}
